import React from 'react';
import PropTypes from 'prop-types';
import checkMark from '../../gif/check-mark.gif';
import checkMarkImage from '../../gif/check-mark.png';
import './SuccessView.scss';
import AnimatedGif from '../AnimatedGif/AnimatedGif';

const SuccessView = ({
  successEventDescription,
  successIconAltText,
  autoCloseDuration = 3000,
  className,
  closeModal,
}) => {
  const customClassName = (name = '') => {
    let customClass = `SuccessView${name}`;
    if (className) {
      customClass = `${customClass} ${className}${name}`;
    }
    return customClass;
  };

  return (
    <div className={customClassName()}>
      <div className={customClassName('--container')}>
        <AnimatedGif
          successImageAltText={successIconAltText}
          gifSrc={checkMark}
          imageSrc={checkMarkImage}
          onAnimationComplete={closeModal}
          className={customClassName('--animation-container')}
          totalDuration={autoCloseDuration}
          animationDuration={1500}
        />
        {successEventDescription && (
        <p
          className={customClassName('--display-text')}
        >
          {successEventDescription}
        </p>
        )}
      </div>
    </div>
  );
};

SuccessView.propTypes = {
  successEventDescription: PropTypes.string,
  successIconAltText: PropTypes.string,
  className: PropTypes.string,
  autoCloseDuration: PropTypes.number,
  closeModal: PropTypes.func.isRequired,
};

SuccessView.defaultProps = {
  successEventDescription: undefined,
  className: undefined,
  autoCloseDuration: 3000,
  successIconAltText: 'Verification completed',
};

SuccessView.displayName = 'SuccessView';
export default SuccessView;
